import { useMemo, useState } from "react"
import { Outlet } from "react-router-dom"
import Navbar from "../navbar"
import Header from "../header"
import { useAppSelector } from "../../hooks"
import { useIsSuperAdmin } from "../../hooks/use-user-roles"
import { selectUser } from "../../../redux/slices/auth"
import { ALLOWED_ROLES_BY_ROUTE, NavbarItems } from "../../constants"
import { getUserRole } from "../../utils"
import { MobileAppPopup } from "../../ui"

const FullLayout = () => {
  const user = useAppSelector(selectUser)
  const isSuperAdmin = useIsSuperAdmin()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const toggleSidebarCollapsed = () => setSidebarCollapsed(!sidebarCollapsed)

  const userRole = getUserRole(user?.user.roles ?? [])
  const navItems = useMemo(() => {
    const items = userRole
      ? NavbarItems[userRole].filter(({ key, hidden }) => {
          const role = getUserRole(user?.user?.roles ?? [])
          return !hidden && role && ALLOWED_ROLES_BY_ROUTE[key].includes(role)
        })
      : []

    return items.map(item =>
      item.key === "dashboard" && !isSuperAdmin
        ? { ...item, name: "Dashboard" }
        : item
    )
  }, [user?.user?.roles, userRole, isSuperAdmin])

  return (
    <div className="h-dvh">
      <Navbar
        items={navItems}
        sidebarOpen={sidebarOpen}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarOpen={setSidebarOpen}
        toggleSidebarCollapsed={toggleSidebarCollapsed}
      />
      <div
        className={`${
          sidebarCollapsed ? "lg:pl-24" : "lg:pl-64"
        } h-full flex flex-col flex-1 transition-all bg-primary-100`}
      >
        <Header setSidebarOpen={setSidebarOpen} />
        <main className="bg-white flex flex-1 overflow-auto flex-col">
          <Outlet />
        </main>
      </div>
      <MobileAppPopup />
    </div>
  )
}

export default FullLayout
